<template>
  <div class="main-help-center">
    <div
      v-if="!isZoomReady"
    >
      <aha-antd-button
        v-if="!isEditor || canUseNewCleanUpEditorUI"
        variant="tertiary"
        icon-name="aha-question2"
        icon-view-box="0 0 16 16"
        @click="openModalHelperCenter"
        v-tooltip="hideTutorialTooltip"
      />
      <!-- Keep editor help button so the help button inside editor has the same style as other buttons in editor -->
      <span
        v-else
        @click="openModalHelperCenter"
        class="tab-trigger-btn text-link font-bold"
      >
        <aha-icon
          class="mr-0 z-10 relative "
          name="question"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          v-tooltip="hideTutorialTooltip"
        />
      </span>
    </div>
    <div v-if="Object.keys(video).length > 0">
      <VideoModalMoveable
        v-if="isEditor"
        @back="backToHelp"
        :video="video"
        @hide="onlyHideOpenModal"
      />
      <VideoModal
        v-else
        @back="backToHelp"
        :video="video"
        @hide="onlyHideOpenModal"
      />
    </div>

    <aha-modal
      no-scroll
      title="Help Centre"
      width="1135px"
      height="55%"
      size="4xl"
      :no-margin-padding="true"
      :visible-overflow="true"
      v-if="isOpenModalHelperCenter"
      @hide="hideModalHelperCenter"
    >
      <div class="grid grid-cols-5">
        <div class="col-span-1">
          <div
            v-for="(tab , index) in tabs"
            :key="index"
            class="border-transparent cursor-pointer p-4 border-radius-2 flex flex-column tab-item items-center"
            :class="{'border-primary-90 active-tab font-bold':activeTab === index}"
            @click.stop="onTab(tab)"
          >
            <aha-icon
              :name="tab.icon"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              class="mr-2 icon-item"
            />
            {{ tab.name }}
            <aha-icon
              v-if="tab.redirect"
              class="pl-1 icon-redirect"
              name="open-new-window"
              width="18"
              height="18"
              viewBox="0 0 24 24"
            />
          </div>
        </div>
        <div class="col-span-4 wrapper-playlist">
          <div class="grid grid-cols-3 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            <div
              v-for="(videoItem, index) in videosToDisplay"
              :key="index"
            >
              <div
                class="cursor-pointer rounded-sm overflow-hidden video-item"
                @click="openVideoModal(videoItem)"
              >
                <div class="video-cta relative">
                  <img :src="videoItem.snippet.thumbnails.maxres.url" />
                  <button class="button-cta-play">
                    <i class="fas fa-play"></i>
                  </button>
                </div>
                <div class="text-sm font-bold video-item-title">
                  {{ videoItem.snippet.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </aha-modal>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import YoutubeApi from '@/api/youtube'
import VideoModal from '@/components-v2/presentation-editor/editor-header/VideoModal.vue'
import VideoModalMoveable from '@/components-v2/presentation-editor/editor-header/VideoModalMoveable.vue'
import EventBus from '@/eventBus'
import Utils from '@/util'
import * as localStorageExpiry from '@/utils/local.storage.expiry'
import { tabs, DEFAULT_PLAY_LIST, TRACKING } from '@/constant/help-center.constant'

export default {
  components: {

    VideoModal,
    VideoModalMoveable,
  },
  props: {
    isEditor: {
      type: Boolean,
      default: true,
    },
  },

  data: () => {
    return {
      loading: false,
      isOpenModalHelperCenter: false,
      videos: [],
      playListId: DEFAULT_PLAY_LIST,
      video: {},
      activeTab: 0,
      isShowTooltipTutorial: false,
      isHoverTooltipTutorial: true,
    }
  },
  computed: {
    ...mapGetters('zoomApp', ['isZoomReady']),
    ...mapGetters('featureToggles', ['canUseNewCleanUpEditorUI']),
    ...mapState({
      currentUser: (state) => state.currentUser,
      isPresenterWhiteLabel: (state) => state.isPresenterWhiteLabel,
    }),
    tabs() {
      const showIntegrationItem = this.currentUser.identifyProvider !== 'skoletube'
        && !this.isPresenterWhiteLabel
      if (!showIntegrationItem) {
        return tabs.filter((tab) => {
          return tab.name !== 'Integrations'
        })
      }

      return tabs
    },
    isMobile() {
      return window.innerWidth < 768
    },
    hideTutorialTooltip() {
      if (!this.isEditor) {
        return false
      }
      if (this.isHoverTooltipTutorial) {
        return this.$i18nPresenter.t('Need the tutorial again? Find it in our Help Centre!')
      }
      return {
        show: this.isShowTooltipTutorial,
        content: this.$i18nPresenter.t('Need the tutorial again? Find it in our Help Centre!'),
      }
    },
    videosToDisplay() {
      return this.videos.filter((video) => !!video.snippet?.thumbnails?.maxres)
    },
  },
  mounted() {
    EventBus.$on('show-tooltip-tutorial', () => {
      // logic show tooltip
      this.isShowTooltipTutorial = true
      this.isHoverTooltipTutorial = false
      setTimeout(() => {
        this.isShowTooltipTutorial = false
        setTimeout(() => {
          this.isHoverTooltipTutorial = true
        }, 300)
      }, 5000)
    })
  },
  methods: {
    backToHelp() {
      this.video = {}
      this.isOpenModalHelperCenter = true
      Utils.mixpanelTracking(
        this.isEditor ? TRACKING.PRESENTATION_EDITOR : TRACKING.PRESENTATION_LIST,
        'Help Center > Tutorial > Back to Help Center',
      )
    },
    hideModalHelperCenter() {
      this.isOpenModalHelperCenter = false
      Utils.mixpanelTracking(
        this.isEditor ? TRACKING.PRESENTATION_EDITOR : TRACKING.PRESENTATION_LIST,
        'Help Center > Close Popup',
      )
    },
    onlyHideOpenModal() {
      EventBus.$emit('show-tooltip-tutorial', true)
      this.video = {}
      Utils.mixpanelTracking(this.isEditor ?
        TRACKING.PRESENTATION_EDITOR : TRACKING.PRESENTATION_LIST,
      'Video tutorial > Close video')
    },
    openVideoModal(video) {
      this.video = video
      this.hideModalHelperCenter()
      Utils.mixpanelTracking(
        this.isEditor ? TRACKING.PRESENTATION_EDITOR : TRACKING.PRESENTATION_LIST,
        'Help Center > Tutorial > Play video',
        video.snippet.title,
      )
    },

    async onTab(tab) {
      Utils.mixpanelTracking(
        this.isEditor ? TRACKING.PRESENTATION_EDITOR : TRACKING.PRESENTATION_LIST,
        `Help Center > ${tab.name}`,
      )
      if (tab.redirect) {
        window.open(tab.redirect, '_blank')
      }
    },
    async openModalHelperCenter() {
      this.isOpenModalHelperCenter = true
      const cachePlayList = localStorageExpiry.getWithExpiry('playlistHelpCenter')
      if (cachePlayList) {
        this.videos = JSON.parse(cachePlayList)
      } else {
        // cache the response of YoutubeAPI for 5 days, because the list would not changed frequently
        await this.fetchDataYoutube(DEFAULT_PLAY_LIST)
        localStorageExpiry.setWithExpiry('playlistHelpCenter', JSON.stringify(this.videos), 432000000)
      }
      Utils.mixpanelTracking(
        this.isEditor ? TRACKING.PRESENTATION_EDITOR : TRACKING.PRESENTATION_LIST,
        'Help Center > Open Popup',
      )
    },

    async fetchDataYoutube(playListId) {
      const playList = await YoutubeApi.getPlayListVideoOnYoutube(playListId, {})
      this.videos = playList.items.filter((video) => !!video.snippet.thumbnails.medium)
      return playList
    },
  },
}
</script>

<style lang="scss" >
.tab-item{
  border-left-width: 8px;
  border-left-style: solid;
  border-left-color: transparent;
  .icon-redirect{
    path{
      fill: rgba(175, 175, 175, 1);
    }
    visibility: hidden;
  }
  &:hover{
    .icon-redirect{
      visibility: visible;
    }
    background: theme('colors.purple.10');
    .icon-item{
      path {
        fill : rgba(25, 31, 45, 1)!important;
      }
    }
  }
}
.icon-item {
  path{
    fill: rgba(153, 153, 153, 1)!important;

  }
}
.button-cta-play {
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ff4954;
  color: #fff;
  transition: 0.1s all;
}
.active-tab{
  background: theme('colors.primary.20');
  border-left-color: theme('colors.primary.90') !important;
  .icon-item{
    path {
      fill : rgba(25, 31, 45, 1)!important;
    }
  }
}
.prez-list-icon{
  position: relative;
  path{
    fill: #313131!important;
  }
  .shadow-hover{
    position: absolute;
    display: block;
    width: 40px;
    height: 40px;
    top: -50%;
    left: -50%;
    background-color: #EEF1F6;
    border-radius: 50px;
    z-index: 5;
    opacity: 0;
    transition: all 0.15s ease-in-out;
  }
  &:hover{
    .shadow-hover{
      opacity: 1;
    }
  }
}

.wrapper-playlist {
  height: 600px;
  overflow-y: scroll;
  padding: 24px 56px 24px 33px;
  border-left: 1px solid var(--secondary-15, #EFF1F7);
  border-top: 1px solid var(--secondary-15, #EFF1F7);
}

.video-item {
  &:hover {
    .video-cta::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: '';
      border: 2px solid theme('colors.primary.90');
      border-radius: 6px;
      z-index: 1;
      inset: 0;
    }

    .video-item-title {
      color: theme('colors.primary.90');
    }
  }
}

.video-cta {
  position: relative;
  overflow: hidden;
  border-radius: 6px;
  margin-bottom: 12px;
  &:hover {
    button {
      opacity: 1;

    }
  }
}

</style>
